<template>
  <div class="logistic">

    <div class="l-box" v-if="logistic.length !== 0">
      <ul>
        <li v-for="item of logistic" :key="item.sn" >
          <div>
            <div class="info">
                <van-tag class="l-com"  size="large" type="primary">{{item.com}}</van-tag>
                <div>
                  <span class="l-sn">{{item.sn}}</span>
                </div>
            </div>
            <div class="remarks">
              <span>备注:</span>
              {{item.remarks}}</div>
          </div>
          <div class="show-detail" @click="show(item.sn)">
            查看详情<van-icon name="arrow" />
          </div>
        </li>
      </ul>
    </div>
    <!-- :image="require('../../assets/icon/logistics.png')" -->
    <van-empty v-if="logistic.length === 0" class="custom-image" description="暂无物流记录" />

    <van-popup v-model="visible" close-icon-position="top-right" :ock-scroll="false" closeable style="height: 90vh; width: 95vw;">

      <div class="content">
        <van-steps :active="active" direction="vertical">

          <van-step v-for="(item,index) of logisticDateil" :key="index">
            <div> {{item.operation}} {{item.content}}</div>
            <div>{{item.time}}</div>
          </van-step>
        </van-steps>
      </div>

    </van-popup>
  </div>
</template>
<script>
import { getOrderLogistics } from '@/api/user'
import { Step, Steps, Popup, Empty,Tag, Icon } from 'vant';

import scroll from '@/mixins/scroll'

export default {
  name: 'logistic',
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    [Tag.name]: Tag,
    [Icon.name]: Icon
  },
  data () {
    return {
      logistic:[],
      visible: false,
      logisticDateil: [],
      active: 0,
      isEmptyLogistic: false

    }
  },
  mixins: [scroll],
  methods: {
    show (sn) {
      this.logistic.map(item => {
        if (item.sn === sn) this.logisticDateil = item.data
      })
      this.visible = true
    },
    async getList () {
      const order_sn = this.$route.query.id
      const result = await getOrderLogistics({
        order_sn,
        page: this.page,
        size: 15
      })
      try {
        if (result.data.data.logistics.length !== 0) {
          this.isEmptyLogistic = true
          this.logistic = this.logistic.concat(result.data.data.logistics)
        } else {
          this.page = null
        }
      } catch (err) { }
    },
  }
}
</script>
<style lang="scss" scoped>
.logistic {
  font-size: 0.28rem;
  .l-box {
    ul {
      width: 95vw;
      margin: auto;
      li {
        padding: 0.2rem;
        background: #eaeaea;
        margin: 0.2rem auto;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .info {
        display: flex;
        margin-bottom: 0.3rem ;
        align-items: center;
        .l-com {
          font-size: 18px;
          padding: 0.1rem;
        }
        .l-sn {
          margin-left: 0.2rem;
          font-size: 15px;
          color: #666;
          width: 3.5rem;
          display: block;
        }
      }
      .remarks{
        width: 5rem;
        word-wrap: break-word;
        color: #666;
        span {
          font-weight: 800;
        }
      }
    }
  }
  .show-detail{
    color: #8b8b8b;
  }
  .content {
    margin-top: 1rem;
    // width: 90vh;
    height: 70vh;
    width: 99%;
    overflow-y: scroll;
  }
}
</style>>